module.exports = __webpack_public_path__ + "static/img/solutionDetailIcon08.a7d1f76.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailIcon08.png
// module id = kDe2
// module chunks = 0